export const updateFilter = (payload) => ({ type:"UPDATE_FILTER_DATE", payload })
export const changeViewToAgenda = (payload) => ({ type: "UPDATE_VIEW", payload: 'agenda' })